import * as React from "react";
import { Base } from "ui/Scripts/source/framework/base";
import { ListLine } from "../framework/listLine";
import { AvatarImage } from "ui/Scripts/source/components/framework/avatarImage";
import { Translations } from "ui/Scripts/source/models/translations";
import { Button } from "ui/Scripts/source/components/framework/button";
import { DialogButtonType } from "ui/Scripts/source/models/enums";
import { IInstantMessageChannelItem } from "ui/Scripts/source/models/instantMessage/instantMessageChannelItem";

//InstantMessageChannelListLine
export interface IInstantMessageChannelListLineProp {
    classes?: boolean;
    channel: IInstantMessageChannelItem;
    userCode: string;
    selected: boolean;
    first: boolean;
    isLastOpenedInstantMessageChannel: boolean;
    onClick: (id: string) => void;
    onLongPress: (id: string) => void;
    onRefreshList: () => void;
    onHandleInvitation: (instantMessageChannelUserId: string, instantMessageChannelId: string, approve: boolean) => void;
}

export class InstantMessageChannelListLine extends React.Component<IInstantMessageChannelListLineProp, {}> {
    getLatestMessageTimeStr = (date: number): string => {
        const dayStr = Base.timeToDateStr(date);
        const yesterdayDayStr = Base.timeToDateStr(new Date().addDays(-1).getTime());
        const todayDayStr = Base.timeToDateStr(new Date().getTime());
        return dayStr === todayDayStr
            ? Base.timeToTimeStr(date)
            : (dayStr === yesterdayDayStr
                ? Translations.Yesterday
                : dayStr);
    };
    
    render() {
        const props = this.props;
        const channel = props.channel;
        if (!channel) return null;
        const latestMessageContent = channel.latestMessage?.getText(props.userCode) ?? "";
        const latestMessageText = channel.latestMessage ? channel.latestMessage.modifyUser.name + (latestMessageContent ? ": " + latestMessageContent : "") : "";
        const latestMessageTime = channel.latestMessage ? this.getLatestMessageTimeStr(channel.latestMessage.modifyUser.date) : "";
        return (
            <ListLine
                id={channel.id}
                first={props.first}
                selected={props.selected}
                classes={"line instantMessageChannelItem" + (props.selected ? " selected" : "") + (channel.active ? "" : " disabled") + (props.isLastOpenedInstantMessageChannel ? " loimc" : "")}
                onClick={channel.invitation ? null : props.onClick}
                onLongPress={channel.invitation ? null : props.onLongPress}
                onRefreshList={props.onRefreshList}>
                <div className={(props.classes ? " " + props.classes : "")}>
                    <div className="value">
                        <AvatarImage
                            id={channel.otherUserCode}
                            classes={channel.hasUnreadMessages ? "pulsing" : ""}
                            name={channel.code}
                            image={channel.getPicture()}
                            imageClass={channel.getPictureClass()}
                            tooltip={channel.code}/>
                        <div className="rightToAvatar">
                            <div className="nameTimeContainer">
                                <div className="name bold">{channel.code}</div>
                                {!!channel.latestMessage &&
                                    <div className="latestMessageTime">{latestMessageTime}</div>
                                }
                            </div>
                            {!!channel.latestMessage &&
                                <div className="latestMessage" title={latestMessageText} dangerouslySetInnerHTML={ { __html: Base.linkifyText(latestMessageText) } }></div>
                            }
                        </div>
                    </div>
                    {!!channel.invitation &&
                        <div>
                            <div className="invitationContainer">
                                <div className="invitationPanel">
                                    <div className="textContainer">
                                        {String.format(Translations.UserParameterHasInvitedYouToJoinInstantMessageChannelParameter, channel.invitation.sender.name)}
                                    </div>
                                    <div className="buttonContainer">
                                        <Button
                                            buttonType={DialogButtonType.Default}
                                            icon="approve"
                                            classes="invitation"
                                            stopPropagation={true}
                                            title={Translations.Approve}
                                            onClick={() => props.onHandleInvitation(channel.invitation.id, channel.id, true)}
                                        />
                                        <Button
                                            buttonType={DialogButtonType.Default}
                                            icon="reject"
                                            classes="invitation"
                                            stopPropagation={true}
                                            title={Translations.Reject}
                                            onClick={() => props.onHandleInvitation(channel.invitation.id, channel.id, false)}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                </div>
            </ListLine>
        );
    }
}